var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"block"},attrs:{"id":"chartContainer"}},[_c('svg',{attrs:{"id":"chart1"}}),_c('svg',{attrs:{"id":"chart2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }